module.exports = __webpack_public_path__ + "static/media/online-tuition-touchpad-with-laptop.0844aa58.jpg";